<template>
  <div>
    <component :is="$config.platform === 'fa' ? 'FaCoursesList' : 'CoursesList'" :list="list">
      <div slot="banner" class="join-banner">
        <div class="banner-container col col-6" :class="$config.platform === 'fa' ? 'md-6' : 'md-8'">
          <p class="h2">
            {{ $c.text('pages.courses.join') }}
          </p>
          <p class="body-1">
            {{ $c.text('pages.courses.joinDescription') }}
          </p>
          <nuxt-link to="/signup/" class="btn-primary" data-event="start_your_career_3.click">
            {{ $c.text($config.platform === 'ds' ? 'button.start-your-career' : 'button.start-now') }}
          </nuxt-link>
        </div>
        <div v-if="$config.platform === 'ds'" class="icons">
          <img src="../../assets/images/pre-footer-icons-1920-dark.webp" alt="Icons">
        </div>
      </div>
    </component>
    <Lazy :when-visible="{ rootMargin: '200px' }">
      <div v-if="list.upcoming.length" class="upcoming-courses course">
        <div class="container container-wide">
          <Slider :disabled="list.upcoming.length <= 3" dark>
            <h3 slot="heading" class="h3">
              Upcoming Courses
            </h3>
            <nuxt-link slot="controls" to="/upcoming-courses/">
              Show All
            </nuxt-link>
            <div
              v-for="course in list.upcoming"
              :key="course.id"
              slot="slide"
              class="col col-4 sm-6 upcoming-wrapper"
            >
              <nuxt-link
                class="upcoming-course"
                :to="`/upcoming-courses/#${course.id}`"
              >
                <div class="image">
                  <div v-if="$config.platform === 'ds'" class="icon" :class="course.technology">
                    <img :src="require(`@itbpbg/lms-components/src/assets/svg/tech-responsive-${course.technology.replace(' ', '-')}.svg`)">
                  </div>
                  <img loading="lazy" :src="`${$config.imagesUrl}/upcoming-courses/${course.instructorPhoto}`" :alt="course.instructor">
                </div>
                <div class="info">
                  <h4 class="h5">
                    {{ course.name }}
                  </h4>
                  <div class="instructors">
                    with {{ course.instructor }}
                  </div>
                </div>
              </nuxt-link>
            </div>
          </Slider>
        </div>
      </div>
    </Lazy>
  </div>
</template>

<script>
import Lazy from 'vue-lazy-hydration';
import CoursesList from '@itbpbg/lms-components/src/Courses/List';
import FaCoursesList from '@itbpbg/lms-components/src/Courses/fa/FaCoursesList';
import Slider from '@itbpbg/lms-components/src/components/Slider';

export default {
  components: {
    Lazy, CoursesList, FaCoursesList, Slider,
  },
  async asyncData({ $axios }) {
    const {
      modules, courses, page, upcoming, tracks, topics,
    } = await $axios.$get('/courses');

    let popularCourses = courses.filter((c) => c.popular).slice(0, 3);
    const inProgress = courses.filter((c) => (c.progress > 0 || c.started) && !c.completed).sort((a, b) => new Date(b.latestCompleted) - new Date(a.latestCompleted));
    const [progress] = inProgress;
    if (progress) {
      const lastPopular = popularCourses.find((p) => p.id === progress.id);
      if (!lastPopular) {
        popularCourses[0] = progress;
      } else {
        popularCourses = [
          progress,
          ...popularCourses.filter((p) => p.id !== progress.id),
        ];
      }
    }

    return {
      list: {
        modules, courses, page, popular: popularCourses, upcoming, tracks, topics,
      },
    };
  },
  data: () => ({
    list: {
      modules: [],
      courses: [],
      upcoming: [],
      page: null,
    },
  }),
};
</script>

<style lang="scss">
.courses-list {
  padding-top: var(--spacing-108);
  background: var(--main-light-shade-1);

  .course-library {
    margin-top: var(--spacing-100);
    padding-bottom: var(--spacing-120);
  }

  .courses-slider .slide .info > div {
    font-size: 14px;
  }

  aside .menu ul {
    margin-top: var(--spacing-16);
    position: relative;

    li.active-background {
      display: none;
      background-color: var(--main-light-shade-2);
      border-radius: 3px;
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      z-index: -1;
      transition: top var(--duration) ease-in;
    }
  }
}

.join-banner {
  display: flex;
  justify-content: center;
  border-radius: 7px;
  color: var(--main-light);
  background-color: var(--main-dark);
  text-align: center;
  padding-top: var(--spacing-80);
  height: 488px;
  position: relative;
  overflow: hidden;

  .banner-container {
    margin: 0 auto;
  }

  p:not(.h2) {
    line-height: 29px;
    margin: 0;
  }

  a {
    margin-top: var(--spacing-48);
    max-width: 300px;
    width: 100%;
    line-height: 33px;
    font-size: 18px;
  }

  .icons {
    position: absolute;
    bottom: -110px;
    left: 0;
    right: 0;

    &:before,
    &:after {
      content: '';
      display: block;
      width: 147px;
      height: 100%;
      position: absolute;
      top: 0;
    }

    &:before {
      background: linear-gradient(90deg, var(--main-dark) 0%, rgba(0, 12, 31, 0.7) 41.67%, rgba(0, 12, 31, 0) 100%);
    }

    &:after {
      right: 0;
      background: linear-gradient(270deg, var(--main-dark) 0%, rgba(0, 12, 31, 0.7) 41.67%, rgba(0, 12, 31, 0) 100%);
    }

    img {
      height: 200px;
    }
  }
}

.upcoming-courses.course {
  background-color: var(--main-dark-shade-1);
  color: var(--main-light);
  padding-top: var(--spacing-100);
  padding-bottom: var(--spacing-120);
  position: relative;
  z-index: 2;

  .slider-header {
    .h3 {
      margin: 0;
    }
  }

  .upcoming-wrapper {
    transition: transform var(--duration) ease;
    padding-bottom: var(--spacing-8);

    &:hover {
      transform: scale(1.03);
    }

    .upcoming-course {
      display: block;
      background-color: var(--main-dark-shade-2);
      border-radius: 7px;
      overflow: hidden;
      height: 100%;
      color: var(--main-light);

      .image {
        position: relative;
        height: 220px;

        .icon {
          position: absolute;
          right: 28px;
          top: 20px;
          z-index: 1;

          img {
            max-width: 44px;
            height: 100%;
            width: 100%;
            filter: drop-shadow(0 2px 10px rgba(0, 12, 31, 0.5));
          }
        }

        > img {
          width: 100%;
          height: 100%;
          -o-object-fit: cover;
          object-fit: cover;
          object-position: 100%;
        }
      }

      .info {
        padding: var(--spacing-24);

        .h5 {
          margin-top: 0;
          margin-bottom: var(--spacing-16);
        }

        .instructors {
          color: var(--main-light-shade-4);
          line-height: 18px;
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .upcoming-courses.course .upcoming-wrapper .upcoming-course .image {
    height: 193px;
  }

  .join-banner {
    a {
      max-width: 225px;
    }
  }
}

@include bp($bp-mobile) {
  .courses-list .course-library {
    margin-bottom: 0;

    .join-banner {
      margin-top: 82px;
      padding: var(--spacing-80) var(--spacing-24) 0 var(--spacing-24);
      border-radius: 0;

      a {
        line-height: 18px;
      }

      .icons {
        &:before,
        &:after {
          display: none;
        }

        img {
          width: 100%;
          height: 140px;
          object-fit: cover;
          object-position: center;
          display: block;
        }
      }
    }
  }

  .upcoming-courses.course {
    background: var(--main-light-shade-1);
    padding-bottom: var(--spacing-80);

    .slider-header {
      justify-content: center;

      h3 {
        color: var(--main-dark-shade-0);
      }
    }

    .slider-container.dark .dots .dot:after {
      background-color: rgba(0, 12, 31, 0.36);
    }

    .slider-container.dark .dots .dot.active:after {
      background-color: var(--main-dark);
    }
  }
}

@include bp($bp-phone) {
  .join-banner {
    height: 583px;

    .icons {
      bottom: 0;

      &:before,
      &:after {
        content: none;
      }
    }
  }
}

.fa {
  @import '@itbpbg/lms-components/src/assets/sass/fa/pages/courses-page.scss';

  .fa-courses-list {
    .join-banner {
      align-items: center;
      background-image: linear-gradient(180deg, rgba(26, 38, 70, 0.1) 96%, #1A2646 100%), url("../../assets/images/fa/fa-courses-banner.jpg");
      border-radius: 0;
      background-repeat: no-repeat;
      background-size: cover;
      height: 706px;
      padding: 220px var(--spacing-24);

      .banner-container {
        .body-1 {
          color: var(--main-light-shade-4);
        }
      }
    }

    @include bp($bp-phone) {
      .join-banner {
        background-image: url("../../assets/images/fa/fa-courses-banner-mobile.jpg");
        background-position: top;
        padding: var(--spacing-60) var(--spacing-24);
        height: auto;
        outline: 1px solid var(--main-dark);

        .banner-container {
          .body-1 {
            line-height: 150%;
            color: var(--accent-light-2);
          }
        }
      }
    }
  }
}
</style>
